<template>
    <div class="section_w patientInfoSection_view">
        <KvTable :items="items"/>
    </div>
</template>

<script>
import KvTable from '@/components/Table/kvTable';
import {_BRAIN_LESION_RANGE} from '@/components/Table/static';
import {GENDER_TRANS} from "@/enum/lib";

export default {
  components: {KvTable},
  props: ['patientProps'],
  data() {
    return {}
  },
  computed: {
    items() {
      return [
        {
          index: 0,
          keyTitle: this.$t('patient.info.email'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientEmail
        },
        {
          index: 1,
          keyTitle: this.$t('user.name'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoName
        },
        {
          index: 2,
          keyTitle: this.$t('patient.info.gender.key'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoGender ?
              this.$t(GENDER_TRANS[this.patientProps.patientInfo.patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans)
        },
        {
          index: 3,
          keyTitle: this.$t('patient.info.date_of_birth'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoBirth ?
              this.moment(this.patientProps.patientInfo.patientInfoBirth).locale(this.$t('country')).format('ll') : '-'
        },
        {
          index: 4,
          keyTitle: this.$t('patient.info.height') + ' ' + `(${this.$store.state.unit === 'metric' ? 'cm' : 'ft'})`,
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoHeight === 0 ? `-`
              : this.$store.state.unit === 'metric' ?
                  parseFloat(parseFloat(this.patientProps.patientInfo.patientInfoHeight).toFixed(1)) :
                  parseFloat((this.patientProps.patientInfo.patientInfoHeight / 30.48).toFixed(2))
        },
        {
          index: 5,
          keyTitle: this.$t('patient.info.weight') + ' ' + `(${this.$store.state.unit === 'metric' ? 'kg' : 'lb'})`,
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoWeight === 0 ? `-`
              : this.$store.state.unit === 'metric' ?
                  parseFloat(parseFloat(this.patientProps.patientInfo.patientInfoWeight).toFixed(1)):
                  parseFloat((this.patientProps.patientInfo.patientInfoWeight * 2.205).toFixed(2))
        },
        {
          index: 6,
          keyTitle: this.$t('patient.condition.primary_diagnosis'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo?.patientInfoPrimaryDiagnosis === '' ?
              `-` : this.patientProps.patientInfo.patientInfoPrimaryDiagnosis
        },
        {
          index: 7,
          keyTitle: this.$t('patient.condition.secondary_diagnosis'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo?.patientInfoSecondaryDiagnosis === '' ?
              `-` : this.patientProps.patientInfo.patientInfoSecondaryDiagnosis
        },
        {
          index: 8,
          keyTitle: this.$t('patient.condition.on_set_date'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.patientProps.patientInfo.patientInfoOccurrenceDate ?
              this.moment(this.patientProps.patientInfo.patientInfoOccurrenceDate).locale(this.$t('country')).format('ll') : '-'
        }
        ,
        {
          index: 9,
          keyTitle: this.$t('patient.condition.brain_lesions'),
          keyType: 'DefaultInfoInput',
          class: '',
          keyRange: [],
          values: this.$t(_BRAIN_LESION_RANGE[this.patientProps.patientInfo?.patientInfoBrainLesion]?.trans)
        }
      ];
    }
  }
}
</script>
<style lang="scss" >
    .patientInfoSection_view {

        .table-container {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 50px;
            width: 100%;
            text-align: left;

            .item-parent {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 0.5rem;
                height: 45px;

                .item-title {
                    flex: 2 1 1rem;
                    font-weight: bold;
                }

                .item-value {
                    flex: 3 3 1rem;
                }

                //.patient_info_value {
                //    .vs--open .vs__dropdown-toggle {
                //        border-bottom-left-radius: 20px !important;
                //        border-bottom-right-radius: 20px !important;
                //        border-top-left-radius: 0px !important;
                //        border-top-right-radius: 0px !important;
                //    }
                //    .vs__dropdown-menu {
                //        top: calc(100% - 257px);
                //        border-radius: 20px 20px 0 0 !important;
                //    }
                //}
            }
        }
    }

</style>